namespace RioERP.Carts {
    export interface CounterProductsRow {
        Id?: number;
        ProductName?: string;
        Description?: string;
        SkuCode?: string;
        EProductType?: number;
        ERioplayVersion?: number;
        RioplayProductCode?: string;
        DownloadUrl1?: string;
        DownloadUrl2?: string;
        HasPenDrive?: boolean;
        HasBooks?: boolean;
        HasCourier?: boolean;
        Note?: string;
        Weight?: number;
        Height?: number;
        Width?: number;
        Length?: number;
        EPackingType?: number;
        GrossAmount?: number;
        EOpens?: number;
        EWatchTime?: number;
        EValidity?: number;
        EValidityType?: number;
        ValidTill?: string;
        TotalAllowedDuration?: number;
        AllowSerialKeyGeneration?: boolean;
        AllowedDevices?: string;
        IsLive?: boolean;
        ProcesOrderOnPaid?: boolean;
        EAccessStatus?: number;
        InAppDownload?: boolean;
        HasVod?: boolean;
        TemplateSerialKeyId?: number;
        IsActive?: boolean;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
        VendorId?: number;
        SupportInfo?: string;
        ProductQueryInfo?: string;
        EShippedby?: number;
        ActivateSerialKey?: boolean;
        IsCombo?: boolean;
        ProductIds?: string;
        WebsiteUrl?: string;
        TeacherName?: string;
        RioPlayTenantId?: number;
        Secretkey?: string;
        Thumbnail?: string;
        VendorName?: string;
        VendorDescription?: string;
        VendorBankName?: string;
        VendorBankAccountType?: number;
        VendorBankAccountName?: string;
        VendorBankAccountNo?: string;
        VendorBankIfscCode?: string;
        VendorAddress?: string;
        VendorCity?: string;
        VendorStateId?: number;
        VendorCountry?: string;
        VendorGstin?: string;
        VendorPan?: string;
        VendorGstCertificate?: string;
        VendorUserId?: number;
        VendorPincode?: number;
        VendorIsActive?: boolean;
        VendorInsertUserId?: number;
        VendorInsertDate?: string;
        VendorUpdateUserId?: number;
        VendorUpdateDate?: string;
        VendorEmail?: string;
    }

    export namespace CounterProductsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'ProductName';
        export const localTextPrefix = 'Carts.CounterProducts';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            ProductName = "ProductName",
            Description = "Description",
            SkuCode = "SkuCode",
            EProductType = "EProductType",
            ERioplayVersion = "ERioplayVersion",
            RioplayProductCode = "RioplayProductCode",
            DownloadUrl1 = "DownloadUrl1",
            DownloadUrl2 = "DownloadUrl2",
            HasPenDrive = "HasPenDrive",
            HasBooks = "HasBooks",
            HasCourier = "HasCourier",
            Note = "Note",
            Weight = "Weight",
            Height = "Height",
            Width = "Width",
            Length = "Length",
            EPackingType = "EPackingType",
            GrossAmount = "GrossAmount",
            EOpens = "EOpens",
            EWatchTime = "EWatchTime",
            EValidity = "EValidity",
            EValidityType = "EValidityType",
            ValidTill = "ValidTill",
            TotalAllowedDuration = "TotalAllowedDuration",
            AllowSerialKeyGeneration = "AllowSerialKeyGeneration",
            AllowedDevices = "AllowedDevices",
            IsLive = "IsLive",
            ProcesOrderOnPaid = "ProcesOrderOnPaid",
            EAccessStatus = "EAccessStatus",
            InAppDownload = "InAppDownload",
            HasVod = "HasVod",
            TemplateSerialKeyId = "TemplateSerialKeyId",
            IsActive = "IsActive",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate",
            VendorId = "VendorId",
            SupportInfo = "SupportInfo",
            ProductQueryInfo = "ProductQueryInfo",
            EShippedby = "EShippedby",
            ActivateSerialKey = "ActivateSerialKey",
            IsCombo = "IsCombo",
            ProductIds = "ProductIds",
            WebsiteUrl = "WebsiteUrl",
            TeacherName = "TeacherName",
            RioPlayTenantId = "RioPlayTenantId",
            Secretkey = "Secretkey",
            Thumbnail = "Thumbnail",
            VendorName = "VendorName",
            VendorDescription = "VendorDescription",
            VendorBankName = "VendorBankName",
            VendorBankAccountType = "VendorBankAccountType",
            VendorBankAccountName = "VendorBankAccountName",
            VendorBankAccountNo = "VendorBankAccountNo",
            VendorBankIfscCode = "VendorBankIfscCode",
            VendorAddress = "VendorAddress",
            VendorCity = "VendorCity",
            VendorStateId = "VendorStateId",
            VendorCountry = "VendorCountry",
            VendorGstin = "VendorGstin",
            VendorPan = "VendorPan",
            VendorGstCertificate = "VendorGstCertificate",
            VendorUserId = "VendorUserId",
            VendorPincode = "VendorPincode",
            VendorIsActive = "VendorIsActive",
            VendorInsertUserId = "VendorInsertUserId",
            VendorInsertDate = "VendorInsertDate",
            VendorUpdateUserId = "VendorUpdateUserId",
            VendorUpdateDate = "VendorUpdateDate",
            VendorEmail = "VendorEmail"
        }
    }
}
